import React, {useMemo} from "react";
import {backgroundColorList} from "../../utils/dashboardUtils";

const LevelPointsConfigChart = ({levelPointsConfig, onePointWidth}) => {
    const items = useMemo(() => {
        const percentWidth = onePointWidth;

        return levelPointsConfig.config.map(({level, min, max, _id}, i) => {
            const width = (max - min) * percentWidth;
            const left = min * percentWidth;
            const color = backgroundColorList[i];

            return (
                <div className="dashboard-charts-level-points-bar" key={_id} style={{width: `${width}%`, left: `${left}%`}}>
                    <p style={{color}}>{`Level ${level}`}</p>
                    <div style={{backgroundColor: color}}/>
                    <label style={{color}}>{`${min}b`}</label>
                    <label style={{color}}>{`${max}b`}</label>
                </div>
            );
        });
    }, [levelPointsConfig, onePointWidth]);

    return (
        <div style={{height: 100}} key={levelPointsConfig._id}>
            <p>{levelPointsConfig.name}</p>
            {items}
        </div>
    );
};

export default LevelPointsConfigChart;
